import React from 'react'
import logo from '../img/logo.png'
import react_logo from '../img/react_logo.png'
import tux_logo from '../img/linux_logo.png'
import db_logo from '../img/db_logo.png'

export const AdminPage = () => {
    return (
        <div className="mui-container z-depth-4">
            <h5>Dashboard</h5>
                <div className="logoblock"><img src={tux_logo} alt="Logo" id="grayscale"/><img src={db_logo} alt="Logo" id="grayscale"/><img src={logo} alt="Logo" id="grayscale"/><img src={react_logo} alt="Logo" id="grayscale"/></div>
                        <div className="row">
                            <div className="col s12 m6 l2">
                            <h6>Menu</h6>
                            <ui className="white-text">
                                <li><a className="grey-text text-lighten-3" href="/create">Create Page</a></li>
                                <li><a className="grey-text text-lighten-3" href="/newpost">Create post</a></li>
                                <li><a className="grey-text text-lighten-3" href="/edit:1">Edit skills</a></li>
                                <li><a className="grey-text text-lighten-3" href="/edit:2">Edit portfolio</a></li>
                                <li><a className="grey-text text-lighten-3" href="/stats">My stats</a></li>
                            </ui>
                            </div>
                            <div className="col s2 m6 l8">
                            <h6>Content</h6>
                            </div>
                            <div className="col s12 m6 l2">
                            <h6>Statistics</h6>
                                <div className="seo white-text"><p>SEO</p></div>
                                <div className="server white-text"><p>Server</p></div>

                            </div>

                        </div>
        </div>
    )
}